import React, { createContext, useContext, useMemo } from 'react'

const AllTreeGroups = createContext()

export const useAllTreeGroups = () => {
  const context = useContext(AllTreeGroups)
  if (!context) throw new Error('You need to use the AllTreeGroupsProvider to use the useAllTreeGroups')
  return context
}

export default function AllTreeGroupsProvider({ children, allGroupsData = {} }) {
  const value = useMemo(() => allGroupsData, [allGroupsData])
  return <AllTreeGroups.Provider value={value}>{children}</AllTreeGroups.Provider>
}
